import en from "vuetify/lib/locale/en";

export default {
  ...en,
  locale: {
    switcherLabel: "Select locale",
  },
};
